import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { MuiThemeProvider } from "@material-ui/core/styles";

// styles
import useStyles, { getMuiTheme } from "./styles";
import { Card, useTheme } from '@material-ui/core';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import List from '../RelateList';
import NoData from '../../../../../../components/NoData';
import { FaIcon } from '../../../../..';
import { get360PaginationData } from "../../../../../../store/actions/module.actions";
import { pathOr } from "ramda";
import SkeletonShell from "../../../../../../components/Skeleton/index";


export default function RelateTile({ data,pid,pmodule }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const currentTheme = useTheme();
  const [page, setPage] = useState(0);
  const [recordCount, setRecordCount] = useState(data.record_count);
  const [related_module] = useState(data.related_module_name);
  const [relateData, setRelateDataModule] = useState(data.related_module_fields );
  
  
  const [loading, setLoading] = useState(false);

  const previousPage = () => {
    setPage(page - 1);
  };
  const nextPage = () => {
    console.log(page?1:2)
  
    setPage(page + (page?1:2));
  };

  useEffect(() => {
    if(page){
    setLoading(true);
    try {
      dispatch(get360PaginationData(pmodule, pid, related_module, page)).then(function (res) {
       if (res) {
          setRelateDataModule(pathOr([], ["Response", "ResponseBody", "Result","related_module_data"], res));
          setLoading(false);

        } else {
          setLoading(false);

        }
      })
    } catch (ex) {
      setLoading(false);

    }
  }

  }, [page])
  const isRecordPreviousForward = (type) => {
    if(type){
      return (page?page:1)*4<recordCount;
    }else{
      return 0<((page*4)-4);

    }
  };
 
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
      <Card className={classes.root}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" className={classes.avatar} style={{ background: data.icon.bgcolor }}>
              <FaIcon icon={`fas ${data.icon.faicon ? data.icon.faicon : "fas fa-cube"}`} size="1x" />

              {/* {data.related_module_name.charAt(0)} */}
            </Avatar>
          }
          action={<>
            <IconButton aria-label="settings" color={isRecordPreviousForward(0)? "primary" : "disabled"} onClick={isRecordPreviousForward(0) ? () => previousPage() : () => { }}>
              <ArrowBackIosIcon />
            </IconButton>
            <IconButton aria-label="settings" color={isRecordPreviousForward(1)? "primary" : "disabled"} onClick={isRecordPreviousForward(1)?() => nextPage():()=>{}}>
              <ArrowForwardIosIcon />
            </IconButton>
          </>

          }
          title={data.related_module_name + "(" + recordCount + ")"}
      
        />
{loading?<SkeletonShell layout='listView' display />:<CardContent>
          {relateData ? <List data={relateData} module={data.related_module_name} related_back_module_name={data.related_back_module_name}/> : <NoData title="No Records Found" type="error" />}
        </CardContent>}

      </Card>
    </MuiThemeProvider>
  );
}